import { Component, OnInit, Input } from '@angular/core';
import { AdOptions, AdSize, AdPosition } from 'capacitor-admob';
import { Plugins } from '@capacitor/core';
import { Storage } from '@ionic/storage-angular';
import { IImmoCalcHistoryData } from 'src/app/interfaces/IImmoCalcHistoryData';
import { IImmoCalcData } from 'src/app/interfaces/IImmoCalcData';
import { ActivatedRoute, Router } from '@angular/router';
const { AdMob, Toast } = Plugins;
import { AdMobFree, AdMobFreeBannerConfig } from '@ionic-native/admob-free';
import { AdMobFreeInterstitialConfig, AdMobFreeRewardVideoConfig } from '@ionic-native/admob-free/ngx';
import { AdmobService } from '../../services/admob.service';
import { AlertController, Platform } from '@ionic/angular';

@Component({
  selector: 'real-estate-calc2',
  templateUrl: './real-estate-calc.component.html',
  styleUrls: ['./real-estate-calc.component.scss'],
})
export class ImmoCalcComponentComponent implements OnInit {
  @Input() name: string;
  history: IImmoCalcHistoryData[] = [];

  constructor(private storage: Storage,
    private router: Router,
    platform: Platform,
    private admobService: AdmobService,
    private route: ActivatedRoute,
    private alertController: AlertController) {


    route.params.subscribe(val => {
      this.loadHistory();
    });
  }

  ngOnInit(): void {
  }

  async openImmoCalcData(immoCalcData: IImmoCalcData) {
    await this.storage.set('immoCalcData', immoCalcData);
    this.router.navigateByUrl('/immo/calc');
  }

  async loadHistory() {
    await this.storage.create();

    this.history = await this.storage.get('history');
    if (!this.history || !this.history.length) {
      this.history = [];
      await this.storage.set('history', this.history);
    }
  }


  async clear(e: any) {
    await this.storage.create();

    e.stopPropagation();
    const alert = await this.alertController.create({
      header: 'Verlauf löschen',
      message: 'Verlauf wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('they hit cancel');
            return Promise.resolve(false);
          }
        }, {
          text: 'Löschen',
          handler: async () => {
            console.log('they hit ok');
            this.history = [];
            await this.storage.set('history', []);
            return Promise.resolve(true);
          }
        }
      ]
    });

    return await alert.present();
  }


  loadInterstitial() {
    const options: AdOptions = {
      adId: 'ca-app-pub-7214709202845307/9004264036',
      autoShow: true
    }
    AdMob.prepareInterstitial(options)
      .then(
        async (value: any) => {
          if (value) {
            // await Toast.show({
            //   text: 'Interstitial AD Loaded'
            // });
            this.showInterstitial();
          }
          console.log(value);  // true
        },
        (error: any) => {
          console.error(error); // show error
        }
      );
  }
  showInterstitial() {
    AdMob.showInterstitial().then(
      async (value: any) => {
        console.log(value);  // true
        // await Toast.show({
        //   text: 'Interstitial AD Showing'
        // });
      },
      (error: any) => {
        console.error(error); // show error
      }
    );
  }



  // This Banner AD have bottom margin to avoid TabBar Overlaping for TabBar 
  showTabBarBanner() {
    const options: AdOptions = {
      adId: 'ca-app-pub-7214709202845307/3610149749',
      adSize: AdSize.BANNER,
      position: AdPosition.BOTTOM_CENTER,
      hasTabBar: false,  // make it true if you have TabBar Layout.
      tabBarHeight: 56  // you can assign custom margin in pixel default is 56
    };

    // Show Banner Ad
    AdMob.showBanner(options)
      .then(
        async (value: any) => {
          console.log(value);  // true
          // await Toast.show({
          //   text: 'Showing Banner AD.'
          // })
        },
        (error: any) => {
          console.error(error); // show error
        }
      );
    // Subscibe Banner Event Listener
    AdMob.addListener('onAdLoaded', async (info: boolean) => {
      console.log('Showing TabBar Banner AD.');
    });


    // this.admobService.ShowBanner();
  }
  hideBanner() {
    AdMob.hideBanner().then(
      async (value: any) => {
        // await Toast.show({
        //   text: 'Banner AD Hidden'
        // })
        console.log(value);  // true
      },
      (error: any) => {
        console.error(error); // show error
      }
    );
  }
  resumeBanner() {
    // Resume the banner, show it after hide
    AdMob.resumeBanner().then(
      (value: any) => {
        console.log(value);  // true
      },
      (error: any) => {
        console.error(error); // show error
      }
    );
  }
  removeBanner() {
    // Destroy the banner, remove it from screen.
    AdMob.removeBanner().then(
      (value: any) => {
        console.log(value);  // true
      },
      (error: any) => {
        console.error(error); // show error
      }
    );
  }

}
